/**
 * Разблокировка страницы после react-bootstrap Modal.
 * Не удаляем узлы .modal из DOM (React сам размонтирует портал).
 * Backdrop снимаем только когда видимых модалок нет.
 */

function hasVisibleModal() {
    if (typeof document === 'undefined') return false;
    return Array.from(document.querySelectorAll('.modal')).some((el) => {
        if (!el.classList.contains('show')) return false;
        const style = window.getComputedStyle(el);
        return style.display !== 'none' && style.visibility !== 'hidden';
    });
}

export function hardBodyUnlock() {
    if (typeof document === 'undefined') return;
    const body = document.body;
    body.classList.remove('modal-open');
    body.removeAttribute('data-rr-ui-modal-open');
    body.style.removeProperty('overflow');
    body.style.removeProperty('paddingRight');
    body.style.removeProperty('padding-right');
    body.style.removeProperty('pointerEvents');
    document.documentElement.style.removeProperty('pointerEvents');
    const root = document.getElementById('root');
    if (root) root.style.removeProperty('pointerEvents');
}

/** Скрывает «залипшие» .modal.show без removeChild — только классы (как InvoiceImportModal) */
function hideStuckModals() {
    if (typeof document === 'undefined') return;
    const modals = Array.from(document.querySelectorAll('.modal.show'));

    modals.forEach((el) => {
        const style = window.getComputedStyle(el);
        const invisible =
            style.display === 'none' ||
            style.visibility === 'hidden' ||
            Number(style.opacity) === 0;
        if (invisible) {
            el.classList.remove('show', 'fade');
            el.style.display = 'none';
        }
    });

    const stillVisible = Array.from(document.querySelectorAll('.modal.show')).filter((el) => {
        const style = window.getComputedStyle(el);
        return style.display !== 'none' && style.visibility !== 'hidden';
    });

    if (stillVisible.length > 1) {
        stillVisible.slice(1).forEach((el) => {
            el.classList.remove('show', 'fade');
            el.style.display = 'none';
        });
    }
}

function removeOrphanBackdrops() {
    if (typeof document === 'undefined') return;
    if (hasVisibleModal()) return;

    document.querySelectorAll('.modal-backdrop, [data-rr-ui-backdrop], .modal-bg, .modal-overlay').forEach((el) => {
        try {
            el.remove();
        } catch (_) {
            /* ignore */
        }
    });
}

function runCleanupPass() {
    hardBodyUnlock();
    hideStuckModals();
    if (!hasVisibleModal()) {
        removeOrphanBackdrops();
        hardBodyUnlock();
    }
}

/** Полная разблокировка — несколько проходов после анимации unmount */
export function restorePageInteractivity() {
    if (typeof document === 'undefined') return;
    [0, 80, 200, 400, 700, 1100].forEach((delay) => {
        setTimeout(runCleanupPass, delay);
    });
}

export function releaseModalLockAfterExit() {
    restorePageInteractivity();
}

export function scheduleModalLockRelease(delayMs = 200) {
    setTimeout(restorePageInteractivity, delayMs);
}

/** @deprecated используйте restorePageInteractivity */
export function releaseModalLock() {
    hardBodyUnlock();
}
